import React from "react";
import { useLanguageContext } from "@/hooks";
import { Button, DialogBox, DialogBoxActions } from "@/_component/Common";
import { NO_IMAGE } from "@/_constant";
import { renderHeading, renderPrice, renderSubtitle, renderTitle } from "@/utility";

// Remove listing Main Component
const RemoveListingConfirmationPopup = ({ listingDetails, onClose, onRemove }) => {
  const { language } = useLanguageContext();

  return (
    <DialogBox title={language("label.remove_listing")} onClose={onClose}>
      <div>
        <p className="fs-5">{language("label.are_you_sure_remove_below_listing")}</p>
        <div className="d-flex gap-3 mt-3">
          <div>
            <img src={listingDetails?.thumbnailUrl || NO_IMAGE} alt="listing-image" className="img-fluid border" style={{ maxHeight: "8rem"}} />
          </div>
          <div className="d-flex flex-column flex-fill gap-2">
            <div>
              <span className="fs-4 fw-bold">{renderPrice(listingDetails)}</span>
            </div>
            <div>
              <div>{renderTitle(listingDetails)}</div>
            </div>
            <div>
              <span>{renderHeading(listingDetails)}</span>
              <span>{renderSubtitle(listingDetails)}</span>
            </div>
          </div>
        </div>
      </div>
      <DialogBoxActions>
        <Button secondary outline rounded onClick={onClose} >
          <i className="bi bi-chevron-left"></i>
          {language("label.Close")}
        </Button>
        <Button danger solid rounded onClick={(e) => onRemove(listingDetails)}>
          <span className="me-2">{language("label.remove")}</span>
          <i className="bi bi-trash-fill"></i>
        </Button>
      </DialogBoxActions>
    </DialogBox>
  );
};

export default RemoveListingConfirmationPopup;
